/* JavaScript controller for Royal Product details section */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    initRoyalProductGalleries();
    initRoyalProductZoom();
    initRoyalProductTabs();
    initRoyalProductQuantitySelectors();
    initRoyalProductOptions();
    initRoyalProductStockSync();
    initRoyalProductReviewScroll();
    initRoyalProductSpecifications();
    initRoyalProductMobileAccordions();
  });

  // Re-run initialization when Shopify theme customizer reloads sections
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.royal-product-container')) {
      initRoyalProductGalleries();
      initRoyalProductZoom();
      initRoyalProductTabs();
      initRoyalProductQuantitySelectors();
      initRoyalProductOptions();
      initRoyalProductStockSync();
      initRoyalProductReviewScroll();
      initRoyalProductSpecifications();
      initRoyalProductMobileAccordions();
    }
  });

  // Gallery Thumbnail Switcher
  function initRoyalProductGalleries() {
    var galleries = document.querySelectorAll('.royal-product__gallery');
    galleries.forEach(function (gallery) {
      var mainImg = gallery.querySelector('.royal-product__main-image');
      var wrap = gallery.querySelector('.royal-product__main-image-wrap');
      var videoSlot = gallery.querySelector('.royal-product__video-slot');
      var thumbs = gallery.querySelectorAll('.royal-product__thumb-item');
      if (gallery.dataset.galleryInitialized) return;
      gallery.dataset.galleryInitialized = 'true';

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          // Reset active class
          thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-pressed', 'false'); });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');

          var isVideo = thumb.dataset.mediaType === 'video' || thumb.dataset.mediaType === 'external_video';
          var template = isVideo && gallery.querySelector('template[data-video-template="' + thumb.dataset.mediaId + '"]');
          if (videoSlot) {
            videoSlot.replaceChildren();
            videoSlot.hidden = !template;
            if (template) videoSlot.appendChild(template.content.cloneNode(true));
            if (template && event.isTrusted) {
              var video = videoSlot.querySelector('video');
              if (video) {
                video.muted = true;
                var playback = video.play();
                if (playback && typeof playback.catch === 'function') playback.catch(function () {});
              }
              var iframe = videoSlot.querySelector('iframe');
              if (iframe && iframe.src) {
                try {
                  var videoUrl = new URL(iframe.src, window.location.href);
                  if (/(^|\.)(youtube\.com|youtube-nocookie\.com|vimeo\.com)$/.test(videoUrl.hostname)) {
                    videoUrl.searchParams.set('autoplay', '1');
                    videoUrl.searchParams.set(videoUrl.hostname.indexOf('vimeo.com') !== -1 ? 'muted' : 'mute', '1');
                    iframe.setAttribute('allow', (iframe.getAttribute('allow') || '') + '; autoplay');
                    iframe.src = videoUrl.toString();
                  }
                } catch (error) {
                  // The embedded player's own controls remain available.
                }
              }
            }
          }
          if (wrap) wrap.classList.toggle('is-video', !!template);
          if (mainImg) mainImg.hidden = !!template;

          // Update main image sources
          var newSrc = thumb.dataset.src;
          if (mainImg && newSrc && !template) {
            mainImg.src = newSrc;
            mainImg.srcset = newSrc;
            var thumbnailImage = thumb.querySelector('img');
            if (thumbnailImage) mainImg.alt = thumbnailImage.alt;
          }
        });
      });
      var activeThumb = gallery.querySelector('.royal-product__thumb-item.is-active');
      if (activeThumb && (activeThumb.dataset.mediaType === 'video' || activeThumb.dataset.mediaType === 'external_video')) activeThumb.click();
    });
  }

  // Interactive Info Tabs Switcher
  function initRoyalProductTabs() {
    var tabContainers = document.querySelectorAll('.royal-product__tabs-container');
    tabContainers.forEach(function (container) {
      var buttons = container.querySelectorAll('.royal-product__tab-btn');
      var panes = container.querySelectorAll('.royal-product__tab-pane');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetTab = btn.dataset.tab;
          if (!targetTab) return;

          // Reset active states
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          panes.forEach(function (p) { p.classList.remove('is-active'); });

          // Set active target
          btn.classList.add('is-active');
          var targetPane = container.querySelector('.royal-product__tab-pane[data-pane="' + targetTab + '"]');
          if (targetPane) {
            targetPane.classList.add('is-active');
            // Force redraw/recalculation for third-party scripts (like image galleries)
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
    });
  }

  // Quantity input controls & Minimum order quantity validation
  function initRoyalProductQuantitySelectors() {
    var qtyContainers = document.querySelectorAll('.royal-product__qty-container');
    qtyContainers.forEach(function (container) {
      var input = container.querySelector('.royal-product__qty-input');
      var btnMinus = container.querySelector('.royal-product__qty-btn--minus');
      var btnPlus = container.querySelector('.royal-product__qty-btn--plus');
      if (!input) return;

      var getMinQty = function () {
        return parseInt(input.getAttribute('min'), 10) || 50;
      };

      var getStep = function () {
        return parseInt(input.getAttribute('step'), 10) || 50;
      };

      // Absent 'max' means the variant is untracked or allows overselling: no ceiling.
      var getMaxQty = function () {
        var max = parseInt(input.getAttribute('max'), 10);
        return isNaN(max) ? null : max;
      };

      var message = container.querySelector('.royal-product__qty-message');
      var messageTimer = null;

      var showMessage = function (text) {
        if (!message) return;
        clearTimeout(messageTimer);
        if (!text) {
          message.hidden = true;
          message.textContent = '';
          return;
        }
        message.textContent = text;
        message.hidden = false;
        messageTimer = setTimeout(function () {
          message.hidden = true;
        }, 5000);
      };

      // Single clamp used by the buttons, manual entry and variant switches, so the
      // value can never exceed stock. This is also what protects the dynamic
      // checkout button, which submits straight to checkout without touching /cart/add.
      var clamp = function (requested, announce) {
        var minQty = getMinQty();
        var maxQty = getMaxQty();
        var step = getStep();
        var val = parseInt(requested, 10);

        if (isNaN(val) || val < minQty) {
          val = minQty;
        } else {
          var remainder = (val - minQty) % step;
          if (remainder !== 0) {
            val = val - remainder + (remainder >= step / 2 ? step : 0);
          }
        }

        if (maxQty !== null && val > maxQty) {
          if (minQty === 25 && step === 5 && maxQty >= minQty) {
            val = minQty + Math.floor((maxQty - minQty) / step) * step;
          } else {
            val = Math.max(minQty, maxQty);
          }
          if (announce) showMessage('Only ' + maxQty + ' available in stock.');
        } else if (announce) {
          showMessage('');
        }

        return val;
      };

      var setQuantity = function (requested, announce) {
        var next = clamp(requested, announce);
        if (String(next) === input.value) return;
        input.value = next;
        // Trigger change event for apps/forms
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      // Minus Button click
      if (btnMinus) {
        btnMinus.addEventListener('click', function (e) {
          e.preventDefault();
          var currentVal = parseInt(input.value, 10) || getMinQty();
          if (currentVal > getMinQty()) {
            setQuantity(currentVal - getStep(), true);
          }
        });
      }

      // Plus Button click
      if (btnPlus) {
        btnPlus.addEventListener('click', function (e) {
          e.preventDefault();
          var currentVal = parseInt(input.value, 10) || getMinQty();
          var maxQty = getMaxQty();
          if (maxQty !== null && currentVal >= maxQty) {
            showMessage('Only ' + maxQty + ' available in stock.');
            return;
          }
          setQuantity(currentVal + getStep(), true);
        });
      }

      // Input box blur / value change validation
      input.addEventListener('change', function () {
        input.value = clamp(input.value, true);
      });

      // Re-applied by the variant switcher after it rewrites the 'max' attribute.
      container.royalSyncQuantityLimit = function () {
        input.value = clamp(input.value, false);
        showMessage('');
      };
    });
  }

  // Option pill buttons linked to native variant dropdown selectors
  function initRoyalProductOptions() {
    var container = document.querySelector('.royal-product-container');
    if (!container) return;
    
    var jsonScript = container.querySelector('[id^="ProductVariantsJson-"]');
    if (!jsonScript) return;
    
    var variants = [];
    try {
      variants = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.error('Failed to parse product variants JSON', e);
      return;
    }

    var optionGroups = container.querySelectorAll('.royal-product__option-group');
    
    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      var currentPriceElem = container.querySelector('.royal-product__price');
      var symbol = '₹';
      if (currentPriceElem) {
        var match = currentPriceElem.textContent.trim().match(/^([^0-9\s,.]+)/);
        if (match) symbol = match[1];
      }
      return symbol + ' ' + (cents / 100).toLocaleString('en-IN');
    }

    optionGroups.forEach(function (group) {
      var pills = group.querySelectorAll('.royal-product__option-pill');
      
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.dataset.value;
          if (!val) return;

          // Set active pill inside this group
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');

          // Gather selected values from all groups
          var selectedOptions = [];
          optionGroups.forEach(function (g) {
            var activePill = g.querySelector('.royal-product__option-pill.is-active');
            if (activePill) {
              selectedOptions.push(activePill.dataset.value);
            }
          });

          // Find matching variant
          var matchingVariant = variants.find(function (v) {
            return v.options.every(function (val, idx) {
              return val === selectedOptions[idx];
            });
          });

          if (matchingVariant) {
            // 1. Find and update all variant ID inputs/selects in the form (handles app-injected inputs)
            var idFields = container.querySelectorAll('[name="id"]');
            idFields.forEach(function (field) {
              field.value = matchingVariant.id;
            });

            // 2. Update price display preserving WPD attributes for the wholesale app
            var priceContainer = container.querySelector('.royal-product__price-container');
            if (priceContainer) {
              var pHandle = priceContainer.getAttribute('data-product-handle') || '';
              var pId = priceContainer.getAttribute('data-product-id') || '';
              var pCollections = priceContainer.getAttribute('data-product-collection-ids') || '';
              
              if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
                var pct = Math.round(((matchingVariant.compare_at_price - matchingVariant.price) * 100) / matchingVariant.compare_at_price);
                priceContainer.innerHTML = 
                  '<span class="royal-product__price price-item price-item--sale" ' +
                    'data-wpd-product-handle="' + pHandle + '" ' +
                    'data-wpd-variant-id="' + matchingVariant.id + '" ' +
                    'data-wpd-variant-price="' + matchingVariant.price + '" ' +
                    'data-wpd-variant-compare-at-price="' + matchingVariant.compare_at_price + '" ' +
                    'data-wpd-product-collection-ids="' + pCollections + '" ' +
                    'data-wpd-product-id="' + pId + '">' +
                    formatMoney(matchingVariant.price) +
                  '</span>' +
                  '<span class="royal-product__price-compare price-item price-item--regular data-wpd-hide">' +
                    formatMoney(matchingVariant.compare_at_price) +
                  '</span>' +
                  '<span class="royal-product__discount-badge data-wpd-hide">' + pct + '% OFF</span>';
              } else {
                priceContainer.innerHTML = 
                  '<span class="royal-product__price price-item price-item--regular" ' +
                    'data-wpd-product-handle="' + pHandle + '" ' +
                    'data-wpd-variant-id="' + matchingVariant.id + '" ' +
                    'data-wpd-variant-price="' + matchingVariant.price + '" ' +
                    'data-wpd-variant-compare-at-price="' + (matchingVariant.compare_at_price || matchingVariant.price) + '" ' +
                    'data-wpd-product-collection-ids="' + pCollections + '" ' +
                    'data-wpd-product-id="' + pId + '">' +
                    formatMoney(matchingVariant.price) +
                  '</span>';
              }
            }

            // 3. Dispatch change event to notify the wholesale app after elements are updated in the DOM (safely caught)
            idFields.forEach(function (field) {
              try {
                field.dispatchEvent(new Event('change', { bubbles: true }));
              } catch (err) {
                console.warn('WCP change dispatch error:', err);
              }
            });

            // 3. Update Add to Cart button state
            var sectionId = container.id.replace('RoyalProduct-', '');
            var atcButton = container.querySelector('#ProductSubmitButton-' + sectionId);
            if (atcButton) {
              var atcText = atcButton.querySelector('span');
              if (matchingVariant.available) {
                atcButton.removeAttribute('disabled');
                if (atcText) atcText.textContent = 'Add to Cart';
              } else {
                atcButton.setAttribute('disabled', 'disabled');
                if (atcText) atcText.textContent = 'Sold Out';
              }
            }

            // 4. Update image gallery main photo
            if (matchingVariant.featured_image) {
              var mainImg = container.querySelector('.royal-product__main-image');
              if (mainImg) {
                mainImg.src = matchingVariant.featured_image;
                mainImg.srcset = matchingVariant.featured_image;
              }
              // Helper to compare URLs ignoring protocol and query parameters
              var cleanUrl = function (u) {
                if (!u) return '';
                return u.replace(/https?:/g, '').split('?')[0];
              };
              var matchTarget = cleanUrl(matchingVariant.featured_image);
              // Set corresponding thumbnail as active
              var thumbs = container.querySelectorAll('.royal-product__thumb-item');
              var matchingThumb = Array.from(thumbs).find(function (thumb) {
                return thumb.dataset.mediaType === 'image' && cleanUrl(thumb.dataset.src) === matchTarget;
              });
              if (matchingThumb) {
                matchingThumb.click();
              } else {
                var gallery = container.querySelector('.royal-product__gallery');
                var slot = gallery && gallery.querySelector('.royal-product__video-slot');
                var wrap = gallery && gallery.querySelector('.royal-product__main-image-wrap');
                if (slot) { slot.replaceChildren(); slot.hidden = true; }
                if (wrap) wrap.classList.remove('is-video');
                if (mainImg) mainImg.hidden = false;
                thumbs.forEach(function (thumb) { thumb.classList.remove('is-active'); thumb.setAttribute('aria-pressed', 'false'); });
              }
            }

            // 5. Update browser history URL
            var newUrl = window.location.pathname + '?variant=' + matchingVariant.id;
            window.history.replaceState({ path: newUrl }, '', newUrl);

            // 6. Update SKU display above product title
            var sectionIdForSku = container.id.replace('RoyalProduct-', '');
            var skuEl = document.getElementById('RoyalProductSku-' + sectionIdForSku);
            if (skuEl) {
              var skuSpan = skuEl.querySelector('span');
              if (matchingVariant.sku && matchingVariant.sku.trim() !== '') {
                if (skuSpan) skuSpan.textContent = matchingVariant.sku;
                skuEl.style.display = '';
              } else {
                if (skuSpan) skuSpan.textContent = '';
                skuEl.style.display = 'none';
              }
            }

            // 7. Re-apply the stock ceiling for the newly selected variant
            var qtyContainer = container.querySelector('.royal-product__qty-container');
            var qtyInput = qtyContainer && qtyContainer.querySelector('.royal-product__qty-input');
            if (qtyInput) {
              var tracked =
                matchingVariant.inventory_management === 'shopify' &&
                matchingVariant.inventory_policy === 'deny';
              var minAttr = parseInt(qtyInput.getAttribute('min'), 10) || 50;
              if (tracked && matchingVariant.inventory_quantity >= minAttr) {
                qtyInput.setAttribute('max', matchingVariant.inventory_quantity);
              } else {
                qtyInput.removeAttribute('max');
              }
              if (typeof qtyContainer.royalSyncQuantityLimit === 'function') {
                qtyContainer.royalSyncQuantityLimit();
              }
              // Then narrow the ceiling further by whatever the cart already holds.
              if (typeof container.royalRefreshStockCeiling === 'function') {
                container.royalRefreshStockCeiling();
              }
            }
          }
        });
      });
    });
  }

  // Image Click Lightbox (Popup to bigger size)
  function initRoyalProductLightbox() {
    var wraps = document.querySelectorAll('.royal-product__main-image-wrap');
    wraps.forEach(function (wrap) {
      var img = wrap.querySelector('.royal-product__main-image');
      if (!img) return;

      wrap.addEventListener('click', function () {
        // Create lightbox elements dynamically
        var lightbox = document.createElement('div');
        lightbox.className = 'royal-product__lightbox';
        
        var content = document.createElement('div');
        content.className = 'royal-product__lightbox-content';
        
        var closeBtn = document.createElement('div');
        closeBtn.className = 'royal-product__lightbox-close';
        closeBtn.innerHTML = '&times;';
        
        var lightboxImg = document.createElement('img');
        lightboxImg.className = 'royal-product__lightbox-img';
        lightboxImg.src = img.src;
        lightboxImg.alt = img.alt || 'Product Image Popup';
        
        content.appendChild(closeBtn);
        content.appendChild(lightboxImg);
        lightbox.appendChild(content);
        document.body.appendChild(lightbox);
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        
        // Trigger opening animation
        setTimeout(function () {
          lightbox.classList.add('is-open');
        }, 10);
        
        // Close function
        var closeLightbox = function () {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
          setTimeout(function () {
            if (lightbox.parentNode) {
              lightbox.parentNode.removeChild(lightbox);
            }
          }, 300);
        };
        
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeLightbox();
        });
        
        lightbox.addEventListener('click', function () {
          closeLightbox();
        });
        
        lightboxImg.addEventListener('click', function (e) {
          e.stopPropagation(); // Clicking the image doesn't close it
        });
      });
    });
  }

  // Smooth scroll from preview stars badge to Judge.me reviews widget section
  function initRoyalProductReviewScroll() {
    document.addEventListener('click', function (e) {
      // Look for clicks on preview badges (stars)
      var badge = e.target.closest('.jdgm-preview-badge') || e.target.closest('.jdgm-prev-badge');
      if (badge) {
        // Look for the main reviews widget
        var widget = document.querySelector('.jdgm-review-widget') || document.querySelector('#judgeme_product_reviews') || document.querySelector('.jdgm-widget');
        if (widget) {
          e.preventDefault();
          e.stopPropagation();
          // Scroll smoothly to it
          widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  // Amazon-style interactive hover zoom
  function initRoyalProductZoom() {
    var wraps = document.querySelectorAll('.royal-product__main-image-wrap');
    wraps.forEach(function (wrap) {
      var img = wrap.querySelector('.royal-product__main-image');
      if (!img) return;

      wrap.addEventListener('mousemove', function (e) {
        var rect = wrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      wrap.addEventListener('mouseleave', function () {
        img.style.transformOrigin = 'center center';
      });
    });
  }

  // Robust JS specifications table parser
  function initRoyalProductSpecifications() {
    var container = document.querySelector('.royal-product-container');
    if (!container) return;
    var sectionId = container.id.replace('RoyalProduct-', '');
    var rawSpecsEl = document.getElementById('RawSpecifications-' + sectionId);
    if (!rawSpecsEl) return;
    
    var specsText = rawSpecsEl.getAttribute('data-raw-specs') || rawSpecsEl.textContent;
    if (!specsText) return;
    
    // Split text cleanly by carriage return or newline
    var lines = specsText.split(/\r?\n/);
    var tableHtml = '';
    lines.forEach(function (line) {
      var cleanLine = line.trim();
      if (!cleanLine) return;
      
      var colonIdx = cleanLine.indexOf(':');
      var dashIdx = cleanLine.indexOf('-');
      var separatorIdx = -1;
      
      // Prioritize colons (common keys) over dashes
      if (colonIdx !== -1) {
        separatorIdx = colonIdx;
      } else if (dashIdx !== -1) {
        separatorIdx = dashIdx;
      }
      
      if (separatorIdx !== -1) {
        var key = cleanLine.substring(0, separatorIdx).trim();
        var val = cleanLine.substring(separatorIdx + 1).trim();
        tableHtml += '<tr><td class="royal-product__specs-label">' + key + '</td><td class="royal-product__specs-value">' + val + '</td></tr>';
      } else {
        tableHtml += '<tr><td class="royal-product__specs-label" colspan="2">' + cleanLine + '</td></tr>';
      }
    });
    
    var specsTable = container.querySelector('.royal-product__specs-table');
    if (specsTable && tableHtml) {
      specsTable.innerHTML = tableHtml;
    }
  }

  // Stock ceiling reconciliation against the cart.
  //
  // The 'max' rendered by Liquid is raw variant inventory, but stock already
  // sitting in the cart is no longer purchasable. Without subtracting it the
  // page happily offers 50 more of a 50-stock item that is already fully in
  // the cart, and /cart/add then rejects it. Dawn does this subtraction in
  // product-info.js (setQuantityBoundries), but this section does not use
  // <product-info>, so it needs its own reconciliation.
  function initRoyalProductStockSync() {
    var container = document.querySelector('.royal-product-container');
    if (!container) return;

    var qtyContainer = container.querySelector('.royal-product__qty-container');
    var input = qtyContainer && qtyContainer.querySelector('.royal-product__qty-input');
    if (!input) return;

    var jsonScript = container.querySelector('[id^="ProductVariantsJson-"]');
    if (!jsonScript) return;

    var variants = [];
    try {
      variants = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.error('Failed to parse product variants JSON', e);
      return;
    }

    var sectionId = container.id.replace('RoyalProduct-', '');
    var atcButton = container.querySelector('#ProductSubmitButton-' + sectionId);
    var message = qtyContainer.querySelector('.royal-product__qty-message');

    var getCurrentVariant = function () {
      var idField = container.querySelector('[name="id"]');
      if (!idField) return null;
      var id = parseInt(idField.value, 10);
      return (
        variants.find(function (v) {
          return v.id === id;
        }) || null
      );
    };

    var refresh = function () {
      var variant = getCurrentVariant();
      if (!variant) return;

      // Untracked or oversell-allowed variants keep no ceiling at all.
      var tracked =
        variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny';
      if (!tracked) {
        input.removeAttribute('max');
        return;
      }

      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var inCart = (cart.items || []).reduce(function (total, item) {
            return item.id === variant.id ? total + item.quantity : total;
          }, 0);

          var remaining = variant.inventory_quantity - inCart;
          var minQty = parseInt(input.getAttribute('min'), 10) || 50;

          if (remaining < minQty) {
            // Nothing orderable is left once the cart is accounted for.
            input.setAttribute('max', Math.max(remaining, 0));
            if (atcButton) {
              atcButton.setAttribute('disabled', 'disabled');
              var label = atcButton.querySelector('span');
              if (label) {
                label.textContent = remaining <= 0 && inCart > 0 ? 'Max quantity in cart' : 'Sold Out';
              }
            }
            if (message) {
              message.textContent =
                inCart > 0
                  ? 'The maximum quantity of this item is already in your cart.'
                  : 'This item is out of stock.';
              message.hidden = false;
            }
            return;
          }

          input.setAttribute('max', remaining);
          if (atcButton && variant.available) {
            atcButton.removeAttribute('disabled');
            var atcLabel = atcButton.querySelector('span');
            if (atcLabel) atcLabel.textContent = 'Add to Cart';
          }
          if (message && !message.hidden) {
            message.hidden = true;
          }
          if (typeof qtyContainer.royalSyncQuantityLimit === 'function') {
            qtyContainer.royalSyncQuantityLimit();
          }
        })
        .catch(function (e) {
          // A failed cart read must not break the page; the server still
          // rejects an over-stock add, and that error renders above the button.
          console.warn('Royal product stock sync failed:', e);
        });
    };

    container.royalRefreshStockCeiling = refresh;

    // Reconcile on load, so a cart populated in an earlier visit is respected.
    refresh();

    // ...and after every add to cart, so the ceiling and button react immediately.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      subscribe(PUB_SUB_EVENTS.cartError, refresh);
    }
  }

  // Mobile accordion toggle for description/details/shipping tabs
  function initRoyalProductMobileAccordions() {
    var accordionBtns = document.querySelectorAll('.royal-product__mobile-accordion-btn');
    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pane = btn.closest('.royal-product__tab-pane');
        if (!pane) return;

        var isOpen = pane.classList.contains('is-open');

        // Close other panes for accordion style toggle
        var allPanes = pane.parentNode.querySelectorAll('.royal-product__tab-pane');
        allPanes.forEach(function (p) {
          p.classList.remove('is-open');
        });

        // Toggle current pane
        if (!isOpen) {
          pane.classList.add('is-open');
        }
      });
    });
  }

})();
